export default {
  "tagsAdmin.thead.index": "#序号",
  "tagsAdmin.thead.tagId": "标签ID",
  "tagsAdmin.thead.groupId": "分组Id",
  "tagsAdmin.thead.tagName": "标签名称",
  "tagsAdmin.thead.groupName": "分组名称",
  "tagsAdmin.thead.tagSeqName": "标签查询名称",
  "tagsAdmin.thead.groupSeqName": "分组查询名称",
  "tagsAdmin.thead.tagIcon": "标签图标",
  "tagsAdmin.thead.tagType": "标签类型",
  "tagsAdmin.thead.color": "标签颜色",
  "tagsAdmin.thead.groupColor": "分组颜色",
  "tagsAdmin.thead.sortWeight": "标签权重",
  "tagsAdmin.thead.status": "状态",
  "tagsAdmin.thead.createTime": "创建时间",
  "tagsAdmin.thead.modifyTime": "修改时间",
  "tagsAdmin.thead.action": "操作",
  "tagsAdmin.add": "添加",
  "tagsAdmin.details": "详情",
  "tagsAdmin.edit": "编辑",
  "tagsAdmin.disable": "禁用",
  "tagsAdmin.enable": "启用",
  "tagsAdmin.gameSort": "游戏排序",
};
